import React from 'react'
// libs
import { ReduxInput } from 'components/FormElements'
// utils
import { required } from 'utils/validators'

interface Props {
  field: string
}

const ResponseMessage: React.FC<Props> = ({ field }) => {
  return <ReduxInput validate={required} multiline label='Message' name={`${field}.message`} />
}

export default ResponseMessage
